import { ParentMessage } from './ParentMessage';
import { Replies } from './Replies';
import { Root } from './Root';

export const StandaloneThread = {
  Root,
  ParentMessage,
  Replies,
};
